import { Database, Loader2, X, FileText, ExternalLink } from 'lucide-react';

export const MasterDataSuggestions = ({ matches, loading, selectedMaster, onApply, onClear, t }) => (
  <>
    {(matches.length > 0 || loading) && (
      <div className="md:col-span-2" data-testid="master-data-suggestions">
        <div className="p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Database className="h-4 w-4 text-blue-600" />
            <span className="text-sm font-semibold text-blue-800 dark:text-blue-300">
              {t('masterData.matchesFound') || 'Stammdaten gefunden'}
            </span>
            {loading && <Loader2 className="h-3 w-3 animate-spin text-blue-500" />}
          </div>
          <div className="space-y-2 max-h-48 overflow-y-auto">
            {matches.map((m) => (
              <button
                key={m.master_id}
                onClick={() => onApply(m)}
                className="w-full text-left p-2 bg-white dark:bg-slate-800 rounded border hover:border-blue-400 transition-colors"
                data-testid={`master-match-${m.master_id}`}
              >
                <p className="font-medium text-sm">{m.supplier_name} - {m.supplier_article_number}</p>
                {m.product_name && <p className="text-xs text-muted-foreground">{m.product_name}</p>}
                <div className="flex flex-wrap gap-2 mt-1 text-xs text-muted-foreground">
                  {m.total_thickness_um && <span>Dicke: {m.total_thickness_um}um</span>}
                  {m.width_mm && <span>Breite: {m.width_mm}mm</span>}
                  {m.certifications && <span>{m.certifications}</span>}
                  {m.data_sheet_url && (
                    <span className="inline-flex items-center gap-1 text-violet-600">
                      <FileText className="h-3 w-3" />
                      Datenblatt
                    </span>
                  )}
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    )}

    {selectedMaster && (
      <div className="md:col-span-2 p-3 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg" data-testid="selected-master-data">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-semibold text-green-800 dark:text-green-300 flex items-center gap-1">
            <Database className="h-4 w-4" />
            {t('masterData.appliedLabel') || 'Stammdaten angewendet'}
          </span>
          <button onClick={onClear} className="text-xs text-muted-foreground hover:text-foreground">
            <X className="h-3 w-3" />
          </button>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs text-muted-foreground">
          {selectedMaster.material_type && <span>Typ: {selectedMaster.material_type}</span>}
          {selectedMaster.face_material && <span>Obermaterial: {selectedMaster.face_material}</span>}
          {selectedMaster.adhesive_type && <span>Klebstoff: {selectedMaster.adhesive_type}</span>}
          {selectedMaster.liner_type && <span>Trager: {selectedMaster.liner_type}</span>}
          {selectedMaster.certifications && <span>Zertif.: {selectedMaster.certifications}</span>}
          {selectedMaster.ean_code && <span>EAN: {selectedMaster.ean_code}</span>}
          {selectedMaster.spec_code && <span>Spec: {selectedMaster.spec_code}</span>}
        </div>
        {selectedMaster.data_sheet_url && (
          <a
            href={selectedMaster.data_sheet_url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 mt-2 px-3 py-1.5 bg-violet-100 dark:bg-violet-900/30 text-violet-700 dark:text-violet-300 rounded-md text-xs font-medium hover:bg-violet-200 dark:hover:bg-violet-900/50 transition-colors"
            data-testid="master-data-sheet-link"
            onClick={(e) => e.stopPropagation()}
          >
            <FileText className="h-3.5 w-3.5" />
            {selectedMaster.data_sheet_filename || 'Datenblatt anzeigen'}
            <ExternalLink className="h-3 w-3" />
          </a>
        )}
      </div>
    )}
  </>
);
